export default __webpack_public_path__ + "d1bdb6f5a23ca6cbab49d5984cd39c5b.png";